export class ProductDirectory {
    dealerGroupId: number; 
    name: String ;
    ordinal: number 
    productCategoryId: number ;
    productId: number;
    constructor (data) {
        this.dealerGroupId = data.dealerGroupId;
        this.name = data.name ;
        this.ordinal = data.ordinal 
        this.productCategoryId = data.productCategoryId ;
        this.productId = data.productId;
    }
   
}


// WEBPACK FOOTER //
// ./src/app/components/class/directory/product.ts